export class PaymentTransactionDto {
  constructor(public paymentDate: Date, public paymentMethodId: number) {}
}
